import { Container } from './styles'
import { NavHashLink, HashLink } from 'react-router-hash-link'
import { useEffect, useState } from 'react'

const Resume = '/Bekhzod_Olimov_CV_English.pdf'
const KoreanResume = '/Bekhzod_Olimov_CV_Korean.pdf'

const THEME_KEY = 'portfolio-theme'

function getInitialTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'dark'
  const stored = window.localStorage.getItem(THEME_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

export function Header() {
  const [isActive, setActive] = useState(false)
  const [theme, setTheme] = useState<'light' | 'dark'>(getInitialTheme)

  useEffect(() => {
    const html = document.documentElement
    html.classList.toggle('light', theme === 'light')
    window.localStorage.setItem(THEME_KEY, theme)
  }, [theme])

  function toggleTheme() {
    setTheme((t) => (t === 'light' ? 'dark' : 'light'))
  }
  function closeMenu() {
    setActive(false)
  }
  return (
    <Container className="header-fixed">
      <HashLink smooth to="#home" className="logo">
        <span>{"<Bekhzod "}</span>
        <span>{" Olimov's"}</span>
        <span>{" Portfolio>"}</span>
      </HashLink>
      <HashLink smooth to="#home" className="logo" lang="ko">
        <span>{"<올리모브 "}</span>
        <span>{" 벡조드의"}</span>
        <span>{" 포트폴리오>"}</span>
      </HashLink>
      <input
        onChange={toggleTheme}
        checked={theme === 'light'}
        className="container_toggle"
        type="checkbox"
        id="switch"
        name="mode"
        aria-label="Toggle light/dark mode"
      />
      <label htmlFor="switch">Toggle light/dark mode</label>
      <nav id="primary-navigation" className={isActive ? 'active' : ''}>
        <NavHashLink smooth to="#home" onClick={closeMenu}>
          Home
        </NavHashLink>
        <NavHashLink smooth to="#about" onClick={closeMenu}>
          Info
        </NavHashLink>
        <NavHashLink smooth to="#project" onClick={closeMenu}>
          Projects
        </NavHashLink>
        <NavHashLink smooth to="#contact" onClick={closeMenu}>
          Contact
        </NavHashLink>
        <a href={Resume} download className="button">
          CV          
        </a>
        <a href={KoreanResume} download className="button" lang="ko">
        이력서
        </a>
      </nav>
      <button
        type="button"
        aria-expanded={isActive}
        aria-controls="primary-navigation"
        aria-label={isActive ? 'Close menu' : 'Open menu'}
        className={isActive ? 'menu active' : 'menu'}
        onClick={() => setActive(!isActive)}
      />
    </Container>
  )
}
